import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import { CardDisplay, LandingCard } from "../../../web-site/components";
import {
  BaseButtons,
  IconOnlyButton,
  LoadingPopUp,
} from "../../../common-components";
import { AddNewCard, ManageCardsPopUp } from "./components";

const WebManagerDisplay = ({
  width,
  height,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  loading,
}) => {
  const [open, setOpen] = useState(false);
  const [displayedIndex, setDisplayedIndex] = useState(0);
  const [manage, setManage] = useState(false);
  const [newCard, setNewCard] = useState(false);
  const [areYouSure, setAreYouSure] = useState(false);

  const [cardtitle, setCardTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [tagLine, setTagLine] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [infoLink, setInfoLink] = useState("");
  const [colorHex, setColorHex] = useState("");
  const [para1, setPara1] = useState("");
  const [para2, setPara2] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [webCards, setWebCards] = useState(null);

  const [selectedCard, setSelectedCard] = useState(null);

  const ScreenDisplayed = (value) => {
    if (value === 0) {
      setDisplayedIndex(1);
    } else if (value === 1) {
      setDisplayedIndex(2);
    } else if (value === 2) {
      setDisplayedIndex(3);
    } else if (value === 3) {
      setDisplayedIndex(4);
    } else if (value === 4) {
      setDisplayedIndex(0);
    } else if (value === 5) {
      setDisplayedIndex(0);
    }
  };
  const SelectCard = (value) => {
    setDisplayedIndex(value);
  };
  const backGroundColorSelecto = () => {
    if (displayedIndex === 0) {
      return colors.greenDark;
    } else if (displayedIndex === 1) {
      return colors.greenLight;
    } else if (displayedIndex === 2) {
      return colors.greenDark;
    } else if (displayedIndex === 3) {
      return colors.greenLight;
    } else if (displayedIndex === 4) {
      return colors.greenDark;
    } else if (displayedIndex === 5) {
      return colors.greenLight;
    }
  };

  const AddNewCardHandler = async () => {
    setLoading(true);
    // https://driverfrienddatabase-h2aa.onrender.com/website/addNewCard
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/website/addNewCard",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            cardTitle: cardtitle ? cardtitle : "",
            subTitle: subTitle ? subTitle : "",
            tagLine: tagLine ? tagLine : "",
            imageLink: imageLink ? imageLink : "",
            paragraph1: para1 ? para1 : "",
            paragraph2: para2 ? para2 : "",
            infoLink: infoLink ? infoLink : "",
            colorHex: colorHex ? colorHex : "",
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.data) {
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("Your card was successful, you can get started....");
        setLoading(false);
        setNewCard(false);
        setRefresh(refresh ? false : true);
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to register because, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to resgister account, some of the information provided is already in our system" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  const ManageCardHandler = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/website/updateCard",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: selectedCard.id,
            cardTitle: cardtitle,
            subTitle: subTitle,
            tagLine: tagLine,
            imageLink: imageLink,
            paragraph1: para1,
            paragraph2: para2,
            infoLink: infoLink,
            colorHex: colorHex,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.id) {
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("Your card was successful, you have updated....");
        setLoading(false);
        setNewCard(false);
        setRefresh(refresh ? false : true);
        setManage(false);
        clearSelection();
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to register because, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to resgister account, some of the information provided is already in our system" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  const DeleteCardhandler = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/website/deleteCard",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: selectedCard.id,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.message === "you have deleted the card") {
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(respnseData.message);
        setLoading(false);
        setNewCard(false);
        setRefresh(refresh ? false : true);
        setManage(false);
        clearSelection();
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to delete because, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setPopUpTitle("FAILED");
      setMessage(
        "could not connect please check your network, if this issue persist contact support."
      );
      setToastPop(true);
    }
  };

  const SelectCardToEdit = () => {
    setSelectedCard(webCards.cards[displayedIndex]);
  };

  const GetCards = async () => {
    await fetch(process.env.REACT_APP_BACKEND_URL + "/website/getCards")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setWebCards(resData);
      });
  };
  const registerationHandler = async () => {
    setLoading(true);
  };

  const clearSelection = () => {
    setImageLink("");
    setCardTitle("");
    setTagLine("");
    setSubTitle("");
    setPara1("");
    setPara2("");
    setInfoLink("");
    setColorHex("");
  };

  useEffect(() => {
    GetCards();
  }, [refresh]);
  // useEffect(() => {
  //   if (selectedCard) {
  //     setImageLink("");
  //     setCardTitle("");
  //     setTagLine("")
  //     setSubTitle("")
  //     setPara1("")
  //     setPara2("")
  //     setInfoLink("")
  //     setColorHex("")
  //   }
  // }, [selectedCard]);
  useEffect(() => {
    setOpen(true);
  }, []);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.8s",
        position: "absolute",
        top: 0,
        backgroundColor: open ? colors.white : colors.primaryPurple,
        flexDirection: "column",
      }}
    >
      <div
        style={{
          height: 50,
          display: "flex",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div style={{ marginLeft: 20 }}>landing Page : Preview</div>
        <div style={{ flex: 1 }}></div>
        <div style={{ marginRight: 10, display: "flex" }}>
          {webCards ? (
            webCards.cards.length >= 5 ? null : (
              <BaseButtons
                label={"+ ADD NEW CARD"}
                backgroundColor={colors.secondaryDarkBlue}
                width={150}
                borderRadius={8}
                height={30}
                onClick={() => {
                  setNewCard(true);
                  clearSelection();
                }}
              />
            )
          ) : null}
          <div style={{ width: 20 }} />
          {areYouSure ? (
            <>
              {" "}
              <BaseButtons
                label={"YES"}
                backgroundColor={colors.secondaryDarkBlue}
                width={100}
                borderRadius={8}
                height={30}
                onClick={() => DeleteCardhandler()}
              />
              <div style={{ width: 20 }} />
              <BaseButtons
                label={"NO"}
                backgroundColor={colors.secondaryDarkBlue}
                width={100}
                borderRadius={8}
                height={30}
                onClick={() => setAreYouSure(false)}
              />
            </>
          ) : (
            <BaseButtons
              label={"DELETE"}
              backgroundColor={colors.secondaryDarkBlue}
              width={100}
              borderRadius={8}
              height={30}
              onClick={() => setAreYouSure(true)}
            />
          )}

          <div style={{ width: 20 }} />
          <BaseButtons
            label={"MANAGE"}
            backgroundColor={colors.secondaryDarkBlue}
            width={100}
            borderRadius={8}
            height={30}
            onClick={() => {
              setManage(true);
              SelectCardToEdit();
            }}
          />
        </div>
      </div>
      <div
        style={{
          flex: 1,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: backGroundColorSelecto(displayedIndex),
          position: "relative",
        }}
      >
        <div style={{ position: "absolute", right: 20, top: 15 }}>
          <IconOnlyButton
            height={50}
            width={50}
            iconImage={require("../../../../images/icons/profileWhite.png")}
          />
        </div>
        <div style={{ position: "absolute", left: 15, top: 15 }}>
          <img
            alt="logo"
            src={require("../../../../images/logo/DriversFriend.png")}
            style={{ height: 60 }}
          />
        </div>
        {webCards
          ? webCards.cards.map((card, index) => {
              return (
                <div
                  key={index}
                  style={{
                    height: displayedIndex === index ? "100%" : 0,
                    width: displayedIndex === index ? "100%" : 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "all 0.5s",
                  }}
                >
                  <LandingCard
                    editorDisplay={true}
                    backgroundColorButton={backGroundColorSelecto()}
                    width={width}
                    display={displayedIndex === index ? true : false}
                    info={card.paragraph1}
                    info2={card.paragraph2}
                    cardImage={card.imageLink}
                    imageHeight={width > 599 ? 300 : 200}
                    onNextClick={() => ScreenDisplayed(index)}
                    cardtitle={card.cardTitle}
                    shortText={width > 599 ? card.tagLine : card.tagLine}
                    subTitle={width > 599 ? card.subTitle : card.subTitle}
                  />
                </div>
              );
            })
          : null}

        <CardDisplay
          width={width}
          marker1={displayedIndex === 0 ? true : false}
          marker2={displayedIndex === 1 ? true : false}
          marker3={displayedIndex === 2 ? true : false}
          marker4={displayedIndex === 3 ? true : false}
          marker5={displayedIndex === 4 ? true : false}
          marker6={displayedIndex === 5 ? true : false}
          onOneClick={() => SelectCard(0)}
          onTwoClick={() => SelectCard(1)}
          onThreeClick={() => SelectCard(2)}
          onFourClick={() => SelectCard(3)}
          onFiveClick={() => SelectCard(4)}
          onSixClick={() => SelectCard(5)}
        />
      </div>
      <ManageCardsPopUp
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
        display={manage}
        onCloseClick={() => {
          setManage(false);
          clearSelection();
        }}
        width={width}
        displayedIndex={displayedIndex}
        imagelink={imageLink}
        onImageLink={(e) => setImageLink(e.target.value)}
        cardTitle={cardtitle}
        subTitle={subTitle}
        onCardChange={(e) => setCardTitle(e.target.value)}
        onSubTitle={(e) => setSubTitle(e.target.value)}
        para1={para1}
        onPara1={(e) => setPara1(e.target.value)}
        para2={para2}
        onPara2={(e) => setPara2(e.target.value)}
        tagLine={tagLine}
        onTagLine={(e) => setTagLine(e.target.value)}
        setImageLink={setImageLink}
        onSaveClick={() => ManageCardHandler()}
      />
      <AddNewCard
        refresh={refresh}
        setRefresh={setRefresh}
        display={newCard}
        onCloseClick={() => {
          setNewCard(false);
          clearSelection();
        }}
        AddNewCardHandler={AddNewCardHandler}
        imagelink={imageLink}
        onImageLink={(e) => setImageLink(e.target.value)}
        cardTitle={cardtitle}
        subTitle={subTitle}
        onCardChange={(e) => setCardTitle(e.target.value)}
        onSubTitle={(e) => setSubTitle(e.target.value)}
        para1={para1}
        onPara1={(e) => setPara1(e.target.value)}
        para2={para2}
        onPara2={(e) => setPara2(e.target.value)}
        tagLine={tagLine}
        onTagLine={(e) => setTagLine(e.target.value)}
      />
      {/* <LoadingPopUp display={loading} /> */}
    </div>
  );
};

export default WebManagerDisplay;
